import type { EditorView } from '@tiptap/pm/view';
import { insertImageFiles } from './insert-image-file';

/**
 * Inserts every pasted clipboard image (screenshots, copied files) as a base64 data URL.
 * ProseMirror only handles HTML/text by default, so file items would otherwise be dropped.
 */
export const handleImagePaste = (view: EditorView, event: ClipboardEvent, isEditorAlive: () => boolean): boolean => {
  const items = event.clipboardData?.items;
  if (!items) {
    return false;
  }

  // getAsFile must be called while the clipboard event is still live, so collect the files up front and read them afterwards.
  const images = Array.from(items)
    .filter((item) => item.kind === 'file' && item.type.startsWith('image/'))
    .map((item) => item.getAsFile())
    .filter((file) => file !== null);

  if (images.length === 0) {
    return false;
  }

  event.preventDefault();
  void insertImageFiles(view, images, isEditorAlive);
  return true;
};
